"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    y: "11.08",
    width: "5",
    height: "8.5",
    rx: "0.5",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.85,15.23a3.23,3.23,0,0,0-3.51-1.12l-3,1a2.61,2.61,0,0,1,.05.48,2.66,2.66,0,0,1-.59,1.7,2.27,2.27,0,0,1-1.79.8H10a.5.5,0,0,1,0-1h5a1.27,1.27,0,0,0,1-.44,1.66,1.66,0,0,0,.36-1.06A1.38,1.38,0,0,0,15,14.08H12a.47.47,0,0,1-.35-.15A5.84,5.84,0,0,0,7.5,12.08H6a.5.5,0,0,0-.5.5v5.5a.49.49,0,0,0,.34.47c1.56.52,2.78,1,3.76,1.33a12.84,12.84,0,0,0,4,1.07c1.15,0,2.13-.53,4.18-1.7,1.35-.78,3.21-1.84,6-3.22a.47.47,0,0,0,.27-.37A.46.46,0,0,0,23.85,15.23Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.12,6.73l-1-1a.32.32,0,0,0-.23-.09h-4.8a3.92,3.92,0,1,0,0,2.61h.42l.55.56a.33.33,0,0,0,.47,0l.55-.56h.39l.55.56a.33.33,0,0,0,.47,0l.55-.56h.85a.32.32,0,0,0,.23-.09l1-1A.33.33,0,0,0,22.12,6.73Zm-11,1.21a1,1,0,1,1,1-1A1,1,0,0,1,11.11,7.94Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;